<div class="modal-height">
  <ziro-directory-number-form
    [modalProperties]="modalProperties"
    (isLoadingDone)="isLoadingDone()"
    (isCancelClicked)="onCancelClicked($event)"
  ></ziro-directory-number-form>
</div>

<ng-template #errorTemplate>
  @if (!areFormsValid) {
    <span>{{ 'tkey;validators.global.required.missing.error' | translate }}</span>
  }
</ng-template>
